<template>
  <div>
    <pop-up
      v-if="$consentManager.getConsentValue('preference')"
      :searchQuery="id"
    />
    <main-jumbotron />
    <Loader
      :text="`HSN CODE: ${searchQuery}`"
      v-if="loading"
      :loading="loading"
    />
    <not-found
      v-else-if="
        Object.values(hsCodeInfo).length === 0 && searchResult.length !== 0
      "
    />
    <div class="four-container" v-else-if="searchResult.length !== 0">
      <b-container>
        <div class="d-flex justify-content-between align-items-center">
          <b-breadcrumb class="p-0 bg-white">
            <b-breadcrumb-item :to="{ name: 'home' }" class="breadcrumb-link">
              Home
            </b-breadcrumb-item>
            <b-breadcrumb-item
              :to="{ name: 'hsTwos', params: { two: chapter } }"
              class="breadcrumb-link"
            >
              Chapter {{ chapter }}
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              <b>{{ searchQuery }}</b>
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
        <b-row>
          <b-col :xs="12" :lg="9">
            <div>
              <h1 class="heading">
                HSN Code <b>{{ searchQuery }}</b> : {{ hsCodeInfo.desc }}
              </h1>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col :xs="12" :lg="9">
            <div>
              <data-table
                v-if="hsCodeInfo.codes"
                :eights="hsCodeInfo"
                :key="searchQuery"
              />
            </div>
          </b-col>
          <b-col :xs="12" :lg="3">
            <!-- <b-card
              :img-src="require(`../../assets/images/tradeview.png`)"
              :title="tradeviewCardTitle"
              class="tradeview-card"
              >
              <b-card-text>Grow your business with Data analytics.</b-card-text>
              <b-button :href="tradeviewLink" size="sm" variant="primary" class="tradeview-btn" target="_blank">Learn More</b-button>
            </b-card> -->
            <div class="banner-wrapper">
              <div class="world-image">
                <b-img-lazy
                  :src="require(`../../assets/images/world-map-banner.png`)"
                  alt="World Map"
                  height="100%"
                  class="world-image"
                />
              </div>
              <div class="heading">
                Get Fast Access to Cash without Collateral
              </div>
              <div class="sub-text">
                Instant Disbursal | High Credit Limit | Lowest Rates | Paperless
                | Transparent
              </div>
              <b-button
                href="https://www.dripcapital.com/en-in/exporters/apply"
                variant="secondary"
                class="mt-4"
              >
                Get Quote
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import MainJumbotron from '@/components/MainJumbotron'
import DataTable from '@/components/DataTable/'
import Loader from '@/components/Loader/'
import LoaderMixin from '@/mixins/loader/'
import NotFound from '@/components/NotFound'
import { hsnQueryMixin } from '@/mixins/query'
import PopUp from '@/components/Popup'

// URL - /hsn-code/XXX
export default {
  data() {
    return {
      searchResult: [],
      loading: false
    }
  },
  metaInfo() {
    const canonicalUrl = `https://www.dripcapital.com/hsn-code/${this.searchQuery}`
    return {
      title: `${this.searchQuery}: ${this.description}`,
      titleTemplate: 'HSN Code %s',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: `Get all 6 digit and 8 digit codes and their GST Rates under HSN Code ${this.searchQuery} ${this.description}`
        }
      ],
      link: [{ rel: 'canonical', href: canonicalUrl }]
    }
  },
  computed: {
    searchQuery() {
      return this.id
    },
    description() {
      return this.hsCodeInfo && this.hsCodeInfo.desc
    },
    hsCodeInfo() {
      return this.searchResult[this.id] || {}
    },
    chapter() {
      return this.searchQuery.substr(0, 2)
    },
    tradeviewLink() {
      return (
        'https://' +
        (process.env.NODE_ENV === 'production' ? 'www' : 'staging') +
        '.dripcapital.com/insights/export-data/india/hsn-code/' +
        this.searchQuery
      )
    },
    tradeviewCardTitle() {
      return `Check Export Data for HS ${this.searchQuery}`
    }
  },
  watch: {
    async $route() {
      await this.hsnQuery()
    }
  },
  async created() {
    await this.hsnQuery()
  },
  mixins: [LoaderMixin, hsnQueryMixin],
  components: {
    DataTable,
    MainJumbotron,
    Loader,
    NotFound,
    PopUp
  },
  props: ['id']
}
</script>

<style lang="scss" scoped>
.four-container {
  padding: 4rem 0;

  .heading {
    margin: 2rem 0;
    line-height: 2rem;
    font-size: 1.25rem;
  }

  .breadcrumb-item {
    &.active,
    a {
      color: $secondary;
    }
  }
}

.tradeview-btn {
  border-radius: 4px;
  line-height: 1.75;
}

.tradeview-card {
  box-shadow: 0 2px 5px #0000000d;
  border: 1px solid $tradeview-card-color;
  border-radius: 4px;
  top: 6.5rem;
  position: sticky;
}

.banner-wrapper {
  background: $search-world-banner;
  text-align: center;
  padding: 20px;
  box-shadow: 0 2px 5px #0000000d;
  border: 1px solid $tradeview-card-color;
  border-radius: 4px;
  top: 6.5rem;
  position: sticky;

  .heading {
    color: $secondary;
    font-weight: bold;
    font-size: 1.4rem;
    margin-bottom: 20px;
  }

  .sub-text {
    color: $grey-sub-text;
  }
}

.world-image {
  height: 100%;
  width: 100%;
  max-height: 250px;
}
</style>
